module.exports = __webpack_public_path__ + "static/media/IT.358e448c.svg";